import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import MaterialTable from 'material-table';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { Layout, UserNavbar } from '../../../../../../components';
import { getVenueTransactions } from './api/venue-transactions-actions';

const headerStyle = {
  color: 'black',
  fontSize: '16px',
  fontWeight: 'bold',
};

export default function VenueTransactions() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [venues, setVenues] = useState([]);

  const getTransactions = async () => {
    setLoading(true);
    const response = await getVenueTransactions();
    if (response) {
      setVenues(response);
    }
    setLoading(false);
  };

  useEffect(() => {
    getTransactions();
  }, []);

  return (
    <Layout>
      <UserNavbar />
      <Grid container justifyContent="center" marginTop={10}>
        <Grid item xs={9} marginBottom={3}>
          <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={4}>
            Venues
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" padding={6}>
        <Grid size={12}>
          <MaterialTable
            onRowClick={(event, rowData) =>
              navigate(`/app/dashboard/venue-transactions/${rowData.id}`)
            }
            isLoading={loading}
            title="Venues list"
            columns={[
              { title: 'Name', field: 'name', headerStyle },
              { title: 'Status', field: 'status', headerStyle },
              { title: 'Contact Email', field: 'contact_email', headerStyle },
              { title: 'Contact name', field: 'contact_name', headerStyle },
              {
                title: 'Website',
                field: 'website',
                headerStyle,
              },
            ]}
            data={venues}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 20, 50],
            }}
          />
        </Grid>
      </Grid>
    </Layout>
  );
}
